<template>
	<div id="leftBar" class="leftBar">
		<div class="leftBox" v-show='curCid == 1'>
			<a v-if="showBigTable" @click="swichTable" class="bigTable">
				<img class="fullimg" :src="imgPath+'home/bigTrun.png'" />
				<div class="time" v-if="TactiveState != 1">
					<span class="hours">{{Thours}}</span>:<span class="minute">{{Tminites}}</span>:<span class="second">{{Tseconds}}</span>
				</div>
			</a>
			<a v-if="voteList" :href="'http://ph.shikee.tv/vote?vid='+voteList[0].vid">
				<img :src="imgPath+'home/vote.png'">
			</a>
		</div>

		<div class="leftBox" v-show='curCid == 9'>
			<a href="http://ph.shikee.tv/store/#/Distribution" class="income">
				<img class="ltimg" :src="imgPath+'user/sales2.png'">
				<p>我的收益</p>
			</a>
			<a href="http://ph.shikee.tv/store/#/orders" class="orders">
				<img class="ltimg" :src="imgPath+'user/orders2.png'">
				<p>我的订单</p>
			</a>
		</div>

		<div v-show="showTable" class="fullBox">
			<turntable v-if="fans_id" ref="turntable" :fansId="fans_id" :showTable="showTable"></turntable>
			<div v-if="!isPlay" class="close" @click="swichTable"><img :src="imgPath+'close.png'"></div>
			<div v-else class="close" style="top:60px" @click="swichTable"><img :src="imgPath+'close.png'"></div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import vxxData from '../../kits/data.js';
import turntable from './turntable.vue';
		//保存数据

export default {
	data() {
		return {
			imgPath:'',
				showTable: false,
				TactiveState: -1,
				Ttimer: '',
				Thours: '',
				Tminites: '',
				Tseconds: '',
		}
	},
	components: {
		turntable,
	},
	props:['curCid','showBigTable','voteList','isPlay','fans_id'],
	mounted() {
		this.imgPath = tool.imgPath();
	},
	methods: {
		swichTable() {
			this.showTable = !this.showTable;
		},
		timeSwitch(S,E) {
			var now = new Date().getTime();
			var start = new Date(S.replace(/-/g, "/")).getTime();
			var end = new Date(E.replace(/-/g, "/")).getTime();
			//console.log(now+'--'+start+'--'+end)
			if(now < start) {
				this.TactiveState = -1;
				this.countDown(parseInt((start - now) / 1000));
				console.log('未开始');
			} else if(now > end) {
				this.TactiveState = 1;
				console.log('已结束');
			} else {
				this.TactiveState = 0;
				this.countDown(parseInt((end - now) / 1000));
				console.log('正在进行');
			}
		},
		countDown(times) {
			clearInterval(this.Ttimer);
			var that = this;
			this.Ttimer = setInterval(function() {
				if(times != 0) {
					times--;
					that.Thours = tool.two(Math.floor(times / 3600));
					that.Tminites = tool.two(Math.floor(times % 3600 / 60));
					that.Tseconds = tool.two(Math.floor(times % 60));
				} else {
					clearInterval(that.Ttimer);
					that.timeSwitch();
				}
			}, 1000)
		},
		getStatus(status){
			this.$refs.turntable.getStatus(status);
		}
	}
}
</script>

<style scoped>
.leftBox {
		position: fixed;
		bottom: 52px;
		left: 10px;
		width: 50px;
		z-index: 1200;
	}
	
	.leftBox a {
		display: block;
		width: 50px;
		height: 50px;
		border-radius: 50%;
		margin-top: 6px;
		font-size: 10px;
		color: #fff;
		position: relative;
		text-align: center;
	}

	.leftBox .income,.leftBox .orders{
		width: 56px;
		height: 56px;
		line-height: 20px;
		border: 2px solid #fff;
		box-shadow: 1px 1px 10px #999;
	}
	.leftBox .income{
		background:linear-gradient(#fe5945,#e63232);
	}
	.leftBox .orders{
		background:linear-gradient(#5494fe,#4277fb);
	}
	
	.leftBox a:first-child {
		margin-top: 0;
	}
	
	.leftBox .fullimg {
		width: 100%;
		vertical-align: middle;
	}
	.leftBox .ltimg {
		width: 20px;
		vertical-align: middle;
		margin-top: 8px;
	}
	
	.leftBox .time {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		min-width: 100%;
		height: 10px;
		line-height: 10px;
		font-size: 10px;
		background: rgb(255, 228, 45);
		color: rgb(255, 64, 34);
		border-radius: 6px;
		padding: 1px 0;
		text-align: center;
	}
</style>